<template>
  <VLoader v-if="loading" />
  <section v-else class="shared-section products">
    <div>
      <header class="shared-section-header">
        <h2 class="shared-section-header-heading">Gift cards</h2>
      </header>
      <div class="flex gap-2 items-center mb-4">
        <div>
          <h3 class="text-3xl font-bold">GIFT CARDS ({{ giftcards.length }})</h3>
        </div>
        <div>
          <a
            href="https://ricoma.com/products/custom-dtf-gang-sheet-builder"
            class="px-3 py-2 text-white rounded-md"
            style="background-color: #3c0285"
            target="_blank"
            >Redeem</a
          >
        </div>
      </div>
      <p class="mb-6">
        To redeem your gift card, simply enter the code at checkout on
        <a
          href="https://ricoma.com/products/custom-dtf-gang-sheet-builder"
          style="color: #f17d21"
          target="_blank"
          class="font-bold underline"
          >ricoma.com.</a
        >
      </p>
      <div v-for="(giftcard, index) in giftcards" :key="`gift-card-${index}`" class="">
        <div
          class="p-5 flex flex-col lg:flex-row gap-5 items-center bg-white rounded-md mb-4 border-l border-l-3"
          style="border-color: #f17d21; border-left-width: 5px"
        >
          <div>
            <img
              class="object-contain object-center w-32 h-32"
              src="../../assets/giftcard-logo.png"
              alt="ad"
            />
          </div>
          <div class="flex gap-8">
            <div>
              <p class="text-sm text-gray-600 font-bold">BALANCE</p>
              <p class="text-2xl font-bold">${{ giftcard.balance }}</p>
            </div>
            <div>
              <p class="text-sm text-gray-600 font-bold">NUMBER</p>
              <p>{{ giftcard.code }}</p>
            </div>
            <div>
              <p class="text-sm text-gray-600 font-bold">EXPIRATION DATE</p>
              <p>{{ giftcard.expires_on ? giftcard.expires_on : 'Valid - no expiration' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';

import { safeNullDataset } from '@/utils';

import VLoader from '@/components/base/VLoader';

export default {
  name: 'Products',
  components: { VLoader },
  data() {
    return {
      loading: false,
    };
  },
  computed: mapState({
    giftcards: state => safeNullDataset(state)(['customer', 'giftcards']),
  }),
  async mounted() {
    !this.giftcards.length && (await this.$store.dispatch('customer/getGiftcards'));
    if (!this.giftcards.length) {
      this.loading = true;
      await this.$store.dispatch('customer/getGiftcards');
      this.loading = false;
    }
  },
};
</script>
